import { cloneDeep } from 'lodash';
import { formatISO, parseISO } from 'date-fns';
import Client from '../client/client';
import DomainDto from './domain-dto';
import DomainStage from './domain-stage';

export default class Domain
{
    public dto!: DomainDto;

    public constructor(dto: DomainDto)
    {
        this.dto = Object.assign({}, dto);

        this._clientId = this.dto.client ? this.dto.client.id : null;
        this._stageId = this.dto.stage ? this.dto.stage.id : null;
    }

    public get id(): number|null
    {
        return this.dto.id;
    }

    public set id(id: number|null)
    {
        this.dto.id = id;
    }

    public get client(): Client|null
    {
        if (!this.dto.client)
        {
            return null;
        }

        return new Client(this.dto.client);
    }

    private _clientId: number|null = null;

    public get clientId(): number|null
    {
        return this._clientId;
    }

    public set clientId(id: number|null)
    {
        this._clientId = id;
    }

    public get stage(): DomainStage|null
    {
        if (!this.dto.stage)
        {
            return null;
        }

        return new DomainStage(this.dto.stage);
    }

    private _stageId: number|null = null;

    public get stageId(): number|null
    {
        return this._stageId;
    }

    public set stageId(id: number|null)
    {
        this._stageId = id;
    }

    public get registrar(): string
    {
        return this.dto.registrar;
    }

    public set registrar(registrar: string)
    {
        this.dto.registrar = registrar;
    }

    public get name(): string
    {
        return this.dto.name;
    }

    public set name(name: string)
    {
        this.dto.name = name;
    }

    public get comments(): string|null
    {
        return this.dto.comments;
    }

    public set comments(comments: string|null)
    {
        this.dto.comments = comments;
    }

    public get dateExpiry(): Date|null
    {
        if (!this.dto.dateExpiry)
        {
            return null;
        }

        return parseISO(this.dto.dateExpiry);
    }

    public set dateExpiry(dateExpiry: Date|null)
    {
        if (!dateExpiry)
        {
            this.dto.dateExpiry = null;
            return;
        }

        this.dto.dateExpiry = formatISO(dateExpiry);
    }

    public get managed(): boolean
    {
        return this.dto.managed;
    }

    public set managed(managed: boolean)
    {
        this.dto.managed = managed;
    }

    public get disabled(): boolean
    {
        return this.dto.disabled;
    }

    public set disabled(disabled: boolean)
    {
        this.dto.disabled = disabled;
    }

    public get dateAdded(): Date
    {
        return parseISO(this.dto.dateAdded);
    }

    public set dateAdded(dateAdded: Date)
    {
        this.dto.dateAdded = formatISO(dateAdded);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get params(): {[key: string]: any}
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dto: any = cloneDeep(this.dto);

        dto.client = this.clientId ? `/clients/${ this.clientId }` : null;
        dto.stage = this.stageId ? `/domain_stages/${ this.stageId }` : null;

        return dto;
    }
}